import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/CloudflareSafeEmailLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/ExamScoreReportsCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pteultra-home/pteultra-home/app/components/HomeAuthCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/HomeClientInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/HomeHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/HomeHeroCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/QuickReadAloudPractice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pteultra-home/pteultra-home/app/components/StudentTestimonialsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/home/runner/work/pteultra-home/pteultra-home/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pteultra-home/pteultra-home/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pteultra-home/pteultra-home/node_modules/next/dist/client/image-component.js");
